import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import ContentSection from "./components/ContentSection";
import ArticleGrid from "./components/ArticleGrid";
import JsonLd from "@/components/feature/JsonLd";
import { websiteJsonLd, organizationJsonLd } from "@/data/seo";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteJsonLd()} />
      <JsonLd data={organizationJsonLd()} />
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <ContentSection />
        <ArticleGrid />
      </main>
      <Footer />
    </div>
  );
}